import { render, staticRenderFns } from "./LSZC.vue?vue&type=template&id=3f2b7ded&"
import script from "./LSZC.vue?vue&type=script&lang=js&"
export * from "./LSZC.vue?vue&type=script&lang=js&"
import style0 from "./LSZC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports